import styled from 'styled-components';
import { ITheme } from '../../styles/theme';

interface IStickyHeader {
  theme: ITheme;
  isIntersecting?: boolean;
  isSticky?: boolean;
}

export const StickyHeader = styled.div<IStickyHeader>`
  top: 0;
  display: flex;
  flex-direction: column;
  z-index: 1;
  ${({ theme, isIntersecting, isSticky }: IStickyHeader) => `
    position: ${isSticky ? 'sticky' : 'relative'};
    transition: all 0.5s;
    ${
  !isIntersecting
    ? `background: linear-gradient(180deg, ${theme.colors.neutral.primary[0]} 0%, transparent 100%);`
    : ''
};
    ${!isIntersecting ? 'padding: 18px 56px 0 56px;' : 'padding: 56px 56px 0 56px'};
  `}
`;

export const CreateSurveyCont = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const MenuMock = styled.div`
  height: 100%;
  width: 427px;
  margin: 0 16px 0 56px;
  background: grey;
`;

export const CreateSurveyBody = styled.div``;
